import { api } from './client';

export interface OrgDigest {
  id: string;
  organization_id: string;
  period_start: string;
  period_end: string;
  messages_count: number;
  summary_md: string;
  generated_at: string;
  generated_by_name: string | null;
  auto: boolean;
}

export interface DigestCreate {
  period_start?: string;
  period_end?: string;
}

export const digestsApi = {
  list: (orgId: string) =>
    api.get<OrgDigest[]>(`/api/v1/organizations/${orgId}/digests`).then(r => r.data),
  create: (orgId: string, payload: DigestCreate = {}) =>
    api.post<OrgDigest>(`/api/v1/organizations/${orgId}/digests`, payload).then(r => r.data),
  remove: (orgId: string, digestId: string) =>
    api.delete(`/api/v1/organizations/${orgId}/digests/${digestId}`),
  chatStats: (orgId: string) =>
    api.get<{ total_messages: number; last_message_at: string | null }>(
      `/api/v1/organizations/${orgId}/digests/_chat_stats`
    ).then(r => r.data),
};
